<template>
  <b-row>
    <b-col sm="12">
      <!-- Cabecera -->
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Informes de Cobranzas</h4>
            <div class="small text-muted">Consulta de informes de cobranzas</div>
          </b-col>     
        </b-row>
      </b-card>

      <!-- Detalle de Reporte -->
      <b-card header-tag="header" footer-tag="footer">        
        <b-row v-if="arr.report">
          <b-col md="6">
            <table class="table table-hover table-sm">
              <tbody>
                <tr v-if="arr.report.id">
                  <td class="reports-payment-detail-title-table-custom align-middle">ID</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">
                    <b>{{arr.report.id}}</b>
                  </td>
                </tr>            
                <tr>
                  <td class="reports-payment-detail-title-table-custom align-middle">Fecha</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">
                    {{moment(arr.report.date).format('DD MMMM YYYY')}}
                  </td>
                </tr>
                <tr>
                  <td class="reports-payment-detail-title-table-custom align-middle">Observaciones</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">
                    {{arr.report.observations}}
                  </td>
                </tr>                         
                <tr v-if="arr.report.canceled">
                  <td class="reports-payment-detail-title-table-custom align-middle">Estado</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">
                    <b-badge variant="danger">Anulado</b-badge>
                    <div class="small text-muted mt-1" v-if="arr.report.reasons_canceled">
                      Motivo: {{ arr.report.reasons_canceled }}
                    </div>
                    <div class="small text-muted" v-if="arr.report.canceled_by">
                      Anulado por: {{ arr.report.canceled_by.name || ('Usuario #' + arr.report.canceled_by.id) }}
                    </div>
                    <div class="small text-muted" v-if="arr.report.canceled_at">
                      Fecha: {{ moment(arr.report.canceled_at).format('DD/MM/YYYY HH:mm') }}
                    </div>
                  </td>
                </tr>                         
                <tr v-if="(arr.report.amounts_items - arr.report.amounts_vouchers) > 0">
                  <td class="reports-payment-detail-title-table-custom align-middle">Anticipo</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">
                    <b><span class="text-danger">$ {{ (arr.report.amounts_items - arr.report.amounts_vouchers).toFixed(2) }}</span></b>
                  </td>
                </tr>                                
              </tbody>
            </table>
          </b-col>

          <b-col md="6">
            <table class="table table-hover table-sm">
              <tbody>
                <tr v-if="arr.report.staff_id">
                  <td class="reports-payment-detail-title-table-custom align-middle">Responsable</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">
                    <b-avatar :src="arr.report.staff.image" v-if="arr.report.staff.image"></b-avatar>
                    <b-avatar v-else variant="dark"></b-avatar>
                    <b-icon icon="blank"></b-icon>
                    <b :title="'STAFF: ' + arr.report.staff.name">{{arr.report.staff.name}}</b>   
                  </td>
                </tr>      
                <tr v-else>
                  <td class="reports-payment-detail-title-table-custom align-middle">Responsable</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">
                    <b-avatar :src="arr.report.seller.staff.image" v-if="arr.report.seller.staff.image"></b-avatar>
                    <b-avatar v-else variant="dark"></b-avatar>     
                    <b-icon icon="blank"></b-icon>
                    <b :title="'VENDEDOR: ' + arr.report.seller.staff.name">{{arr.report.seller.staff.name}}</b> 
                  </td>
                </tr>

                <tr v-if="arr.report.customer">
                  <td class="reports-payment-detail-title-table-custom align-middle">Cliente</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">                    
                    <b-avatar :src="arr.report.customer.image" v-if="arr.report.customer.image"></b-avatar>
                    <b-avatar v-else icon="building" variant="dark"></b-avatar>     
                    <b-icon icon="blank"></b-icon>
                    <b v-if="parameters.codeCustomer">({{arr.report.customer.code}}) {{arr.report.customer.name}}</b>    
                    <b v-else>{{arr.report.customer.name}}</b>
                    <b-icon icon="circle-fill" v-if="!arr.report.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                                                       
                  </td>
                </tr>

                <tr v-if="arr.report.surrender_detail">
                  <td class="reports-payment-detail-title-table-custom align-middle">Rendición</td>
                  <td class="reports-payment-detail-value-table-custom align-middle">                      
                    <div class="ml-1">
                      <b-badge v-if="arr.report.surrender_detail.status=='Enviado'" variant="info" class="report-payment-surrender-badge">{{arr.report.surrender_detail.status}}</b-badge>
                      <b-badge v-if="arr.report.surrender_detail.status=='En Revisión'" variant="warning" class="report-payment-surrender-badge">{{arr.report.surrender_detail.status}}</b-badge>
                      <b-badge v-if="arr.report.surrender_detail.status=='Aprobado'" variant="success" class="report-payment-surrender-badge">{{arr.report.surrender_detail.status}}</b-badge>
                      <b-badge v-if="arr.report.surrender_detail.status=='Rechazado'" variant="danger" class="report-payment-surrender-badge">{{arr.report.surrender_detail.status}}</b-badge>
                      <b-badge v-if="arr.report.surrender_detail.status=='No Recibido'" variant="secondary" class="report-payment-surrender-badge">{{arr.report.surrender_detail.status}}</b-badge>        
                    </div>            
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>

        <!-- Que cancela / Vouchers -->
        <b-row>
          <b-col md="6">
            <b-card>
              <div slot="header">
                <i class="icon-docs"></i><strong> Que cancela</strong>
              </div>
              <b-table
                v-if="arr.report && arr.report.vouchers"
                :items="arr.report.vouchers"
                :fields="fields_vouchers"
                small
                hover
                responsive="sm"
                head-variant="dark"
                foot-variant="dark">

                <template v-slot:cell(amount)="data">
                  $ {{ data.item.amount }}
                </template>

                <template v-slot:cell(amount_discount)="data">
                  $ {{ calculateVoucherDiscount(data.item) }}
                </template>

                <template v-slot:cell(amount_final)="data">
                  $ {{ calculateVoucherTotal(data.item) }}
                </template>

                <template v-slot:cell(discounts_variation)="data">
                  <span>{{ discountLabel(data.item) }}</span>
                  <b-badge
                    v-if="hasMixedDiscounts(data.item) || voucherHasParticularDiscounts(data.item)"
                    variant="danger"
                    class="ml-1"
                  >!</b-badge>
                </template>

                <template v-slot:cell(actions)="data">
                  <b-button size="sm" variant="link" @click="data.toggleDetails()">
                      <b-icon :icon="data.detailsShowing ? 'dash' : 'plus'"></b-icon>
                  </b-button>
                </template>
                
                <template #row-details="row">
                  <b-card>
                    <b-table small striped hover
                            :items="row.item.detail"
                            :fields="fields_discount"
                            responsive="sm"
                            class="mb-2">

                      <template v-slot:cell(desc1)="data">
                        {{ data.item.discount_1 }}%
                      </template>
                      <template v-slot:cell(desc2)="data">
                        {{ data.item.discount_2 }}%
                      </template>
                      <template v-slot:cell(desc3)="data">
                        {{ data.item.discount_3 }}%
                      </template>
                      <template v-slot:cell(desc4)="data">
                        {{ data.item.discount_4 }}%
                      </template>
                      <template v-slot:cell(total_discount)="data">
                        $ {{ calculateDiscount(data.item) }}
                      </template>
                    </b-table>
                  </b-card>
                </template>

                <template v-slot:custom-foot>
                  <b-tr>
                    <b-td colspan="2" class="text-right"><strong>Totales</strong></b-td>
                    <b-td class="text-right"><strong>$ {{ totalVoucherAmount }}</strong></b-td>
                    <b-td class="text-right"><strong>$ {{ totalVoucherDiscount }}</strong></b-td>
                    <b-td class="text-right"><strong>$ {{ totalVoucherFinal }}</strong></b-td>
                    <b-td colspan="2"></b-td>
                  </b-tr>
                </template>
              </b-table>
            </b-card>
          </b-col>

          <!-- Desglose de Pago -->
          <b-col md="6">
            <b-card>
              <div slot="header">
                <i class="fa fa-money"></i><strong> Desglose de Pago</strong>
              </div>
              <b-table class="mb-0"
                responsive="sm"
                head-variant="dark"
                :hover="true"
                :small="true"
                :fixed="false"
                :items="arr.report.items"
                :fields="fields_payment"
                v-if="arr.report">

                <template v-slot:cell(id)="data"><strong>{{data.item.id}}</strong></template>
                <template v-slot:cell(type)="data">{{data.item.type}}</template>
                <template v-slot:cell(date)="data"><span v-if="data.item.date">{{moment(data.item.date).format('DD MMMM YYYY')}}</span></template>
                <template v-slot:cell(nro_certificate)="data">{{data.item.nro_certificate}}</template>
                <template v-slot:cell(check)="data">
                  <div v-if="data.item.type=='Cheque'">                    
                    <div :id="'popover-target-' + data.index" class="badge badge-secondary text-wrap popover-size-custom">Más Info Cheque</div>
                    <b-popover :target="'popover-target-' + data.index" title="Info Cheque" triggers="hover" placement="left">                    
                      <table>                      
                        <tr><td class="reports-payment-popover-header-item">Tipo</td><td>{{data.item.check_type.toUpperCase()}}</td></tr>                      
                        <tr><td class="reports-payment-popover-header-item">Banco</td><td>{{data.item.check_bank}}</td></tr>
                        <tr><td class="reports-payment-popover-header-item">Número</td><td>{{data.item.check_number}}</td></tr> 
                        <tr><td class="reports-payment-popover-header-item">Fecha de Pago</td><td><div v-if="data.item.check_date_movement">{{moment(data.item.check_date_movement).format('DD/MM/YYYY')}}</div></td></tr>
                        <tr><td class="reports-payment-popover-header-item">CUIT Emisor</td><td>{{data.item.check_cuit}}</td></tr>                      
                        <tr><td class="reports-payment-popover-header-item">Observaciones</td><td>{{data.item.check_observations}}</td></tr>                        
                      </table>
                    </b-popover>                      
                  </div>    
                </template>
                <template v-slot:cell(attachment)="data">
                  <div v-if="data.item.image">
                    <b-link :href="data.item.image" target="_blank" rel="noopener">
                      Ver archivo
                    </b-link>
                  </div>
                  <span v-else class="text-muted">Sin archivo</span>
                </template>

                <template v-slot:custom-foot>
                  <b-tr>
                    <b-td colspan="6" class="text-right"></b-td>
                    <b-td class="text-right"><strong>$ {{ totalAmount }}</strong></b-td>
                  </b-tr>
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>

      </b-card>

      <!-- Botón Volver -->
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i> Volver
            </b-button>                        
          </b-col>          
        </b-row>
      </b-card>

    </b-col>
  </b-row>
</template>

<script>
import serviceAPI from './services'
import Error from '@/handler/error'
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper' 
import moment from 'moment'
import Param from '@/config/parameters'

export default {
  data: () => ({
    access: {
      module_id: Modules.INFORME_COBRANZAS,
      profile_id: Profiles.PERSONAL,
      view_reference: 'detailReport',
      elements: {}
    }, 
    parameters: { codeCustomer: Helper.hasParametersAccess(Param.P2) },          
    reportID: 0,
    fields_payment: [
      {key: 'id', label: 'ID', sortable: true},
      {key: 'type', label: 'Medio'},  
      {key: 'date', label: 'Fecha'},  
      {key: 'nro_certificate', label: 'Nro. Constancia'},  
      {key: 'check', label: 'Info Extra', class:'text-center'},
      {key: 'attachment', label: 'Adjunto'},
      {key: 'amount', label: 'Importe', class:'text-right'},          
    ],
    fields_vouchers: [                    
      {key: 'date', label: 'Fecha', class:'text-left'},
      {key: 'vouchers', label: 'Comprobante', class:'text-center'},    
      {key: 'amount', label: 'Importe', class:'text-right'},       
      {key: 'amount_discount', label: '$ Descuento', class:'text-right'},      
      {key: 'amount_final', label: 'Total', class:'text-right'},      
      { key: 'discounts_variation', label: 'Desc.', class: 'text-center' },
      { key: 'actions', label: '', class: 'text-center' }    
    ],
    fields_discount: [
      { key: 'description', label: 'Descripción' },
      { key: 'desc1', label: 'Desc 1', class: 'text-right' },
      { key: 'desc2', label: 'Desc 2', class: 'text-right' },
      { key: 'desc3', label: 'Desc 3', class: 'text-right' },
      { key: 'desc4', label: 'Desc 4', class: 'text-right' },
      { key: 'total_discount', label: 'Descuento', class: 'text-right' }
    ],
    arr: { report: null },
    openedVouchers: []        
  }),
  mounted() {
    this.reportID = this.$route.params.reportID
    this.load()
  },
  computed: {
    totalAmount() {
      if (!this.arr.report || !this.arr.report.items) return 0;
      return this.arr.report.items.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0).toFixed(2)
    },
    openVoucherList() {
      if (!this.arr.report || !this.arr.report.vouchers) return [];
      return this.arr.report.vouchers.filter(v => this.isVoucherOpen(v.id));
    },
    totalVoucherDiscount() {
      if (!this.arr.report || !this.arr.report.vouchers) return 0;
      return this.arr.report.vouchers.reduce((sum, voucher) => {
        return sum + parseFloat(this.calculateVoucherDiscount(voucher));
      }, 0).toFixed(2);
    },
    totalVoucherAmount() {
      if (!this.arr.report || !this.arr.report.vouchers) return 0;
      return this.arr.report.vouchers.reduce((sum, voucher) => {
        return sum + parseFloat(voucher.amount);
      }, 0).toFixed(2);
    },
    totalVoucherFinal() {
      if (!this.arr.report || !this.arr.report.vouchers) return 0;
      return this.arr.report.vouchers.reduce((sum, voucher) => {
        return sum + parseFloat(this.calculateVoucherTotal(voucher));
      }, 0).toFixed(2);
    },
    // Combo de descuentos más común en todo el reporte (a nivel renglón)
    reportModeDiscountCombo() {
      if (!this.arr.report || !this.arr.report.vouchers) return null
      const counter = new Map()
      for (const v of this.arr.report.vouchers) {
        if (!v.detail) continue
        for (const it of v.detail) {
          const d1 = Number(it.discount_1) || 0
          const d2 = Number(it.discount_2) || 0
          const d3 = Number(it.discount_3) || 0
          const d4 = Number(it.discount_4) || 0
          const key = `${d1}|${d2}|${d3}|${d4}`
          counter.set(key, (counter.get(key) || 0) + 1)
        }
      }
      if (counter.size === 0) return null
      let bestKey = null
      let bestCount = -1
      for (const [k, c] of counter.entries()) {
        if (c > bestCount) { bestKey = k; bestCount = c }
      }
      return bestKey
    }
  },
  methods: {
    validation() {        
      const seller = Helper.getSeller()                        
      if(seller && this.arr.report && this.arr.report.sellers_id != seller.id) {
        this.$router.push({ name: 'Error403' })
      }
    },      
    load() {
      serviceAPI.mostrar(this.reportID)
        .then((response) => {
          this.arr.report = response.data
          this.validation()
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
    },    
    calculateVoucherDiscount(voucher) {
      if (!voucher.detail) return 0;

      return voucher.detail.reduce((sum, item) => {
        return sum + parseFloat(this.calculateDiscount(item))
      }, 0).toFixed(2);
    },

    calculateVoucherTotal(voucher) {
      const discount = parseFloat(this.calculateVoucherDiscount(voucher));
      return (voucher.amount - discount).toFixed(2);
    },
    toggleVoucherDetail(row) {
      row.toggleDetails()
    },
    isVoucherOpen(row) {
      return row.detailsShowing
    },
    hasMixedDiscounts(voucher) {
      if (!voucher || !voucher.detail || voucher.detail.length <= 1) return false
      const seen = new Set()
      for (const it of voucher.detail) {
        const d1 = Number(it.discount_1) || 0
        const d2 = Number(it.discount_2) || 0
        const d3 = Number(it.discount_3) || 0
        const d4 = Number(it.discount_4) || 0
        const key = `${d1}|${d2}|${d3}|${d4}`
        seen.add(key)
        if (seen.size > 1) return true
      }
      return false
    },
    voucherHasParticularDiscounts(voucher) {
      if (!voucher || !voucher.detail || !this.reportModeDiscountCombo) return false
      // Marca si algún renglón del voucher difiere del combo más común del reporte
      return voucher.detail.some(it => {
        const d1 = Number(it.discount_1) || 0
        const d2 = Number(it.discount_2) || 0
        const d3 = Number(it.discount_3) || 0
        const d4 = Number(it.discount_4) || 0
        const key = `${d1}|${d2}|${d3}|${d4}`
        return key !== this.reportModeDiscountCombo
      })
    },
    discountLabel(voucher) {
      if (!voucher || !voucher.detail) return ''
      return this.discountCombosLabel(voucher)
    },
    discountCombosLabel(voucher) {
      if (!voucher || !voucher.detail) return ''
      const seen = new Set()
      const labels = []
      for (const it of voucher.detail) {
        const d1 = Number(it.discount_1) || 0
        const d2 = Number(it.discount_2) || 0
        const d3 = Number(it.discount_3) || 0
        const d4 = Number(it.discount_4) || 0
        const key = `${d1}|${d2}|${d3}|${d4}`
        if (!seen.has(key)) {
          seen.add(key)
          const parts = [d1, d2, d3, d4].filter(n => n > 0)
          labels.push(parts.length ? parts.join('/') : '0')
        }
      }
      return labels.join(', ')
    },
    calculateDiscount(item) {
      let total = 0
      let remaining = item.amount || 0

      if(item.discount_1) {
        let d1 = remaining * item.discount_1 / 100
        total += d1
        remaining -= d1
      }

      if(item.discount_2) {
        let d2 = remaining * item.discount_2 / 100
        total += d2
        remaining -= d2
      }

      if(item.discount_3) {
        let d3 = remaining * item.discount_3 / 100
        total += d3
        remaining -= d3
      }

      if(item.discount_4) {
        let d4 = remaining * item.discount_4 / 100
        total += d4
        remaining -= d4
      }

      return total.toFixed(2)
    }
  }    
}
</script>

<style>
  .reports-payment-detail-title-table-custom {
    color: #fff;
    background-color: #2f353a;
    border-color: #40484f;
    font-weight: 700;
    padding-right: 10px;
    width: 25%;
    text-align: right;
  }
  .reports-payment-detail-value-table-custom {
    padding-left: 5px;
    white-space: pre-line;
  }
  .reports-payment-popover-header-item {  
    font-size: 14px !important;
    font-weight: 700 !important;   
    padding-right: 5px !important;      
  }
  .reports-payment-text-red { color: red; }  
  .reports-payment-text-green { color: green; }    
</style>

<style scoped>
  .b-avatar { width: 25px; height: 25px; }  
</style>
